<template>
  <div>
    <div class="mdc-card pda-24  cursor-pointer" v-if="myStatus=='BADGE'" @click="moveToDetail(badgeList.boxId,badgeList.missionId)" @keypress="moveToDetail(badgeList.boxId,badgeList.missionId)" tabindex="0">
      <div class="badge-container">
        <img :src="badgeList.on.resourceUri" :alt="badgeList.on.name" class="icon84 mgx-auto" v-if="badgeList && badgeList.on && badgeList.on.resourceUri" />
        <!-- <span class="t-helper d-flex justify-content-center align-items-center h-21 w-31 bg-iconInactive t-color-white badgeFlag">X1</span> -->
      </div>
      <div class="mgt-16 t-body3 t-line-h-22 t-center font-r min-h-44">{{$t(badgeList.name) | charLength}}</div>
      <div class="mgt-8 t-center t-color-bodyGrayA t-helper font-rn t-line-h-16 font-r">{{$moment(badgeList.achievedDate).format('L')}}</div>
    </div>
    <div class="mdc-card pda-24 cursor-pointer" v-if="myStatus=='AVAILABLE'" @click="moveToDetail(badgeList.id)" @keypress="moveToDetail(badgeList.id)" tabindex="0">
      <div class="badge-container available">
          <img :src="badgeList.on.resourceUri" :alt="badgeList.on.name" class="icon84 mgx-auto" v-if="badgeList && badgeList.on && badgeList.on.resourceUri" />
          <!-- <span
              class="t-helper d-flex justify-content-center align-items-center h-21 w-31 bg-iconInactive t-color-white badgeFlag">X1</span> -->
      </div>
      <div class="mgt-16 t-body3 t-line-h-22 t-center font-r min-h-42">{{$t(badgeList.name) | charLength}}</div>
      <div class="mgt-8 t-center t-color-bodyGrayA t-helper font-rn t-line-h-16 font-r">~ {{ badgeEndTime(badgeList.operating.end) }}</div>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 아이템 컴포넌트(my learning main list item component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { dateConstants } from "@/utils/constants/DateConstants";


export default {
  props: ["badgeList", "myStatus"],
  data() {
    return {
      learnProgressRate: {},
    };
  },
    filters:{
        charLength(value) {
            if(value.length>30){
                return value.substring(0,30)+".."
            } else {
                return value
            }

        },
    },
  mounted() {},

  computed: {},
  methods: {
    // 학습진행율 데이터 (get learning status data)
    moveToDetail(boxid,missionId){
      this.$router.push({
        path: this.myStatus === "BADGE" ? `/badgedetail/${boxid}/${missionId}` : `/badgeavailabledetail/${boxid}`, 
      })
    },

    badgeEndTime(time) {
      return time >= dateConstants.maximumDate ? this.$t("50013") : this.$moment(time).format("L");
    }
  },
};
</script>
